import { default as $ } from 'dinero.js'

$.globalFormat = '0.00'
$.globalLocale = 'en'

function formatNumber(num: number | string) {
  const val = typeof num === 'number' ? num.toFixed(2) : num
  const parts = val.split('.')
  let formatted = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ')
  if (parts[1]) {
    const fraction = parts[1].padEnd(2, '0')
    formatted += `,${fraction}`
  } else {
    formatted += `,00`
  }
  return formatted
}

function deformatNumber(num: string) {
  return String(num)
    .replace(/ /g, '')
    .replace(',', '.')
    .replace(/^[0]+([1-9])/, '$1')
}

function formatMoney(money: string | any) {
  return formatNumber(
    typeof money !== 'object' ? money : money.toRoundedUnit(2),
  )
}

export function displayMoney(
  amount,
  decimalCount = 2,
  decimal = ',',
  thousands = ' ',
) {
  try {
    decimalCount = Math.abs(decimalCount)
    decimalCount = isNaN(decimalCount) ? 2 : decimalCount

    const negativeSign = amount < 0 ? '-' : ''

    const i = parseInt(
      (amount = Math.abs(Number(amount) || 0).toFixed(decimalCount)),
    ).toString()
    const j = i.length > 3 ? i.length % 3 : 0

    const decimalAmount = Math.abs(amount - Number(i))
      .toFixed(decimalCount)
      .slice(2)

    const price =
      negativeSign +
      (j ? i.substr(0, j) + thousands : '') +
      i.substr(j).replace(/(\d{3})(?=\d)/g, `$1${thousands}`) +
      (decimalCount && Number(decimalAmount) ? decimal + decimalAmount : '')

    return price
  } catch (e) {
    // eslint-disable-next-line no-console
    console.log(e)
  }
}

function mapItemToPrice(item: string) {
  let price = item || '0.00'

  if (typeof price === 'number') {
    price = String(Number(item) * 100)
  }

  if (!price.includes(',') && !price.includes('.')) {
    price = `${item}.00`
  }
  if (price.includes('.') && price.split('.')[1].length === 1) {
    price = `${price}0`
  }

  return item &&
    item !== '0.00' &&
    item !== undefined &&
    !isNaN((price as unknown) as number)
    ? $({ amount: Number(price.replace(',', '').replace('.', '')) })
    : $({ amount: 0 })
}

export { mapItemToPrice, formatMoney, formatNumber, deformatNumber }
export default $
